import React from 'react';

import DesktopMenu from './DesktopMenu';
import DeviceMenu from './DeviceMenu';
import { IMenu } from '../../interfaces/menu.interface';
import { IPageContext } from '../../interfaces/pagecontext.interface';

interface Props {
  menu: IMenu[];
  pageContext: IPageContext;
  headerDesktopMenuClass?: string;
}

const Navigation: React.FC<Props> = ({ menu, pageContext, headerDesktopMenuClass }): React.ReactElement => {
  return (
    <>
      <DesktopMenu menu={menu} pageContext={pageContext} headerDesktopMenuClass={headerDesktopMenuClass} />
      <DeviceMenu menu={menu} pageContext={pageContext} headerDesktopMenuClass={headerDesktopMenuClass} />
    </>
  );
};

export default Navigation;
